import React, { Fragment } from 'react';
import { getDangerousHtml } from '../../helpers/components';
import { wrapOptionId } from '../../helpers/strings';
import LayflatIcon from '../LayflatIcon';

const BookSizeSwatch = ({ labelProps, swatchProps }) => {
  const option = swatchProps.option || {};

  return (
    // PDPRedesign A/B Test
    <Fragment>
      <label
        {...labelProps}
        className="PDPRedesign--ControlElement"
        htmlFor={wrapOptionId(option.id)}
        dangerouslySetInnerHTML={getDangerousHtml(option.display_label)}
      />
      <label
        {...labelProps}
        className="PDPRedesign--AlbumSize-Swatch"
        htmlFor={wrapOptionId(option.id)}
      >
        <LayflatIcon size={option.label} />
        <p>{option.label}"</p>
      </label>
    </Fragment>
  );
};

export default BookSizeSwatch;



// WEBPACK FOOTER //
// ./src/components/RadioInput/BookSizeSwatch.js